import React, { useMemo } from 'react'

import Image from 'next/image'

import { Column } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { WELCOME_SECTION_GALLERY_ITEMS } from './constants'
import { Card, DesktopContainer, MobileContainer } from './styles'

const LOGO_WIDTH = { MOBILE: 166, DESKTOP: 216 }
const LOGO_HEIGHT = { MOBILE: 100, DESKTOP: 160 }

function WelcomeSectionGallery() {
  const { isDesktop, isWideDesktop } = useResponsiveLayout()

  const { firstRowItems, secondRowItems } = useMemo(() => {
    return {
      firstRowItems: WELCOME_SECTION_GALLERY_ITEMS.slice(0, 4),
      secondRowItems: WELCOME_SECTION_GALLERY_ITEMS.slice(4),
    }
  }, [])

  return (
    <Column alignCenter fullWidth>
      {isDesktop || isWideDesktop ? (
        <>
          <DesktopContainer>
            {firstRowItems.map(item => (
              <Card
                height={LOGO_HEIGHT.DESKTOP}
                key={item.id}
                width={LOGO_WIDTH.DESKTOP}
              >
                <Image alt={item.alt} fill src={item.image.src} />
              </Card>
            ))}
          </DesktopContainer>

          <DesktopContainer>
            {secondRowItems.map(item => (
              <Card
                height={LOGO_HEIGHT.DESKTOP}
                key={item.id}
                width={LOGO_WIDTH.DESKTOP}
              >
                <Image alt={item.alt} fill src={item.image.src} />
              </Card>
            ))}
          </DesktopContainer>
        </>
      ) : (
        <MobileContainer>
          {WELCOME_SECTION_GALLERY_ITEMS.map(item => (
            <Card
              height={LOGO_HEIGHT.MOBILE}
              key={item.id}
              width={LOGO_WIDTH.MOBILE}
            >
              <Image alt={item.alt} fill src={item.image.src} />
            </Card>
          ))}
        </MobileContainer>
      )}
    </Column>
  )
}

export default WelcomeSectionGallery
